const CLIENT_ID = "myaccount";
const PROTOCOL_VERSION = 2;
const ACCOUNTS_URL = process.env.REACT_APP_IDENTITY_URL || "https://accounts.clikkle.com";
const PRODUCTION_REDIRECT = "https://myaccount.clikkle.com/";
const INTENDED_ROUTE_KEY = "clikkle.identity.myaccount.intendedRoute";
const AUTH_CALLBACK_KEYS = new Set(["userId", "refreshToken", "securityLevel"]);

const getRedirectUri = () => {
  if (typeof window === "undefined") return PRODUCTION_REDIRECT;
  if (window.location.hostname === "localhost" || /^192\.168\./.test(window.location.hostname)) return `${window.location.origin}/`;
  return PRODUCTION_REDIRECT;
};

const sanitizeSearch = (search = "") => {
  const params = new URLSearchParams(search);
  AUTH_CALLBACK_KEYS.forEach((key) => params.delete(key));
  const value = params.toString();
  return value ? `?${value}` : "";
};

export const saveIdentityDestination = () => {
  if (typeof window === "undefined") return;
  const route = `${window.location.pathname}${sanitizeSearch(window.location.search)}${window.location.hash}`;
  if (!route.startsWith("/login") && !route.startsWith("/signup")) sessionStorage.setItem(INTENDED_ROUTE_KEY, route);
};

export const consumeIdentityDestination = (fallback = "/") => {
  const value = sessionStorage.getItem(INTENDED_ROUTE_KEY);
  sessionStorage.removeItem(INTENDED_ROUTE_KEY);
  return value && value.startsWith("/") ? value : fallback;
};

export const buildIdentityUrl = (mode = "login") => {
  saveIdentityDestination();
  const path = mode === "signup" ? "/register" : "/login";
  const url = new URL(path, ACCOUNTS_URL);
  url.searchParams.set("client_id", CLIENT_ID);
  url.searchParams.set("identity_protocol_version", String(PROTOCOL_VERSION));
  url.searchParams.set("redirect_uri", getRedirectUri());
  url.searchParams.set("referralApp", "My Clikkle");
  return url.toString();
};

export const beginIdentityLogin = () => { window.location.assign(buildIdentityUrl("login")); };
export const beginIdentityRegistration = () => { window.location.assign(buildIdentityUrl("signup")); };
export const IDENTITY_CLIENT = Object.freeze({ id: CLIENT_ID, protocolVersion: PROTOCOL_VERSION, redirectUri: getRedirectUri() });
